import React from 'react';

export const CIMCavado = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-[#003d82] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Horários CIM Cávado</h1>
            <p className="text-xl text-gray-200">
              Linha Póvoa de Varzim - Barcelos operada pela Litoral Norte
            </p>
          </div>
        </div>
      </section>

      {/* Line Info Card */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-[#003d82] to-[#004a9c] text-white rounded-2xl p-8 md:p-12 shadow-2xl">
              <h2 className="text-3xl font-bold mb-6">Linha CIM Cávado</h2>
              <p className="text-xl text-gray-200 mb-8">
                A Litoral Norte opera a linha de transporte público da Comunidade Intermunicipal do Cávado, 
                ligando a Póvoa de Varzim a Barcelos.
              </p>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 mb-8">
                <div className="flex items-start gap-4">
                  <div className="bg-[#f5a623] text-[#003d82] font-bold text-2xl px-6 py-3 rounded-lg flex-shrink-0">
                    CIM
                  </div>
                  <div>
                    <div className="text-2xl font-bold mb-2">Póvoa de Varzim - Barcelos</div>
                    <div className="text-gray-200">
                      Serviço regular de transporte intermunicipal conectando a Póvoa de Varzim a Barcelos
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-[#f5a623] text-[#003d82] rounded-xl p-6 text-center">
                <h3 className="text-2xl font-bold mb-3">Consulte os Horários Oficiais</h3>
                <p className="mb-6 text-lg">
                  Para horários detalhados e atualizados, visite o site oficial da CIM Cávado:
                </p>
                <a
                  href="https://aitc.cimcavado.pt/horarios/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#003d82] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#002a5c] transition-all duration-300 hover:shadow-xl hover:scale-105"
                >
                  Aceder ao Site CIM Cávado →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Operator Info */}
            <div className="bg-[#003d82] text-white p-6 rounded-lg mb-6">
              <h3 className="text-xl font-bold mb-3">Sobre o Serviço CIM Cávado</h3>
              <p className="text-gray-200">
                A <strong>Litoral Norte</strong> tem o orgulho de operar esta importante ligação intermunicipal 
                que conecta a Póvoa de Varzim a Barcelos, garantindo mobilidade entre os dois concelhos.
              </p>
            </div>

            <div className="bg-[#f5a623]/10 border-l-4 border-[#f5a623] p-6 rounded-lg">
              <h3 className="text-xl font-bold text-[#003d82] mb-3">Informações Importantes</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Para horários atualizados e detalhados, consulte o <a href="https://aitc.cimcavado.pt/horarios/" target="_blank" rel="noopener noreferrer" className="text-[#003d82] font-semibold hover:text-[#f5a623] underline">site oficial da CIM Cávado</a></li>
                <li>• Em feriados e dias especiais, os horários podem sofrer alterações</li>
                <li>• Para informações sobre tarifas, consulte o site oficial</li>
                <li>• Recomendamos que chegue à paragem com 5 minutos de antecedência</li>
                <li>• Para mais informações, contacte-nos através do telefone 252 692 266</li>
              </ul>
            </div>

            <div className="mt-8 text-center">
              <p className="text-gray-600 mb-4">
                Tem dúvidas sobre horários ou destinos?
              </p>
              <a
                href="tel:252692266"
                className="inline-flex items-center gap-2 bg-[#003d82] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#002a5c] transition-all"
              >
                Contacte-nos
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
